import classNames from 'classnames';
import { useSwiper } from 'swiper/react';
import ContentNavigation from '@/components/molecules/content-navigation/content-navigation';
import styles from './secondary-header-navigation.module.scss';

export interface SecondaryHeaderNavigationProps {
  /** The class name to apply */
  className?: string;
  /** The current index */
  currentIndex?: number;
  /** */
  onClickFullscreen?: () => void;
  /** The total page count */
  pageCount?: number;
}

const SecondaryHeaderNavigation = ({
  className,
  currentIndex,
  onClickFullscreen,
  pageCount,
}: SecondaryHeaderNavigationProps) => {
  const swiper = useSwiper();

  const handleClickNext = () => {
    swiper.slideNext();
  };

  const handleClickPrevious = () => {
    swiper.slidePrev();
  };

  return (
    <div className={classNames(styles.component, className)}>
      <ContentNavigation
        className={styles.navigation}
        currentIndex={currentIndex}
        itemType="image"
        onClickFullscreen={onClickFullscreen}
        onClickNext={handleClickNext}
        onClickPrevious={handleClickPrevious}
        pageCount={pageCount}
      />
    </div>
  );
};

SecondaryHeaderNavigation.displayName = 'SecondaryHeaderNavigation';

export default SecondaryHeaderNavigation;
